import React, { Component } from "react";
import { connect } from "react-redux";
import { ListItem } from "material-ui/List";
import * as scheduleSelectors from "../store/schedule/scheduleSelectors";
import * as colors from "../constants/colors";
import * as globalStyles from "../constants/styles";
import { changeColor } from "../util/color";
import MatchMenu from "./MatchMenu";

class Match extends Component {
  render() {
    const { matchId, match } = this.props;
    if (!match) {
      return null;
    }
    const { games, home, away, field } = match;
    return (
      <ListItem
        disableTouchRipple={true}
        primaryText={
          <div style={styles.content}>
            <div style={styles.name}>
              {home} - {away}
            </div>
            <div style={styles.resultContainer}>
              {games.length > 0 && (
                <div style={styles.result}>{games.join(", ")}</div>
              )}
            </div>
          </div>
        }
        secondaryText={"Bana " + field}
        rightIconButton={
          <div>
            <MatchMenu matchId={matchId} />
          </div>
        }
      />
    );
  }
}

const styles = {
  content: {
    display: "flex",
    alignItems: "center"
  },
  name: {
    flex: 2
  },
  resultContainer: {
    flex: 1
  },
  result: {
    display: "inline-block",
    backgroundColor: colors.grey,
    color: changeColor(colors.grey, 0.2),
    padding: globalStyles.space / 4,
    borderRadius: globalStyles.space / 4
  }
};

const mapStateToProps = (state, initialProps) => {
  const { matchId } = initialProps;
  return {
    match: scheduleSelectors.getMatchById(state, matchId)
  };
};

export default connect(mapStateToProps, null)(Match);



// WEBPACK FOOTER //
// ./src/components/Match.js